export const BASE_URL = 'https://api.themisbot.com';